/** Turn `/uploads/...` into absolute URL for <img src>. */
export function uploadsPublicUrl(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  const api = process.env.REACT_APP_API_URL || 'https://api.webcard.digital/api';
  const base = api.replace(/\/?api\/?$/, '').replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
